jQuery(document).ready(function ($) {
    /**
     * 
     * PAGINA ELENCO ANNUNCI
     * 
     * 
     * 
     */
    $('.user-stars-rating').change(function () {
        $('.button-vota').prop("disabled", false);
    });

    var commonOLangTabelleAnnunci = {
        "sLengthMenu": "Mostra _MENU_ risultati per pagina",
        "sZeroRecords": "Nessun annuncio trovato",
        "sInfo": "Visualizzati annunci da _START_ a _END_ di _TOTAL_ risultati",
        "sInfoEmpty": "Mostra 0 su 0 di 0 risultati",
        "sInfoFiltered": "(Filtrati da _MAX_ risultati totali)",
        "sSearch": "Filtra:",
        "oPaginate": {
            "sFirst": "|<",
            "sLast": ">|",
            "sNext": ">",
            "sPrevious": "<"
        }
    };

    $('#table-elenco-annunci-prestito').DataTable({
        responsive: true,
        "fnDrawCallback": reinizializzaTooltips,
        "columns": [
            {"data": "Foto"},
            {"data": "Nome Annuncio"},
            {"data": "Oggetto"},
            {"data": "Punto ToornaQui"},
            {"data": "Zona Ritiro"},
            {"data": "Indirizzo proprietario annuncio"},
            {"data": "Beneficiario"},
            {"data": "Stato Transazione"},
            {"data": "Data Annuncio"},
            {"data": "Azioni"}
        ],
        "oLanguage": commonOLangTabelleAnnunci,
        "aoColumnDefs": [{"bSortable": false, "aTargets": [0, 9]}]
    });
    $('#table-elenco-annunci-prenotati').DataTable({
        responsive: true,
        "fnDrawCallback": reinizializzaTooltips,
        "columns": [
            {"data": "Foto"},
            {"data": "Nome Annuncio"},
            {"data": "Oggetto"},
            {"data": "Stato Transazione"},
            {"data": "Data Annuncio"},
            {"data": "Azioni"}
        ],
        "oLanguage": commonOLangTabelleAnnunci,
        "aoColumnDefs": [{"bSortable": false, "aTargets": [0, 5]}]
    });
    $('#table-elenco-annunci-offro').DataTable({
        responsive: true,
        "fnDrawCallback": reinizializzaTooltips,
        "columns": [
            {"data": "Foto"},
            {"data": "Nome Annuncio"},
            {"data": "Oggetto"},
            {"data": "Punto ToornaQui"},
            {"data": "Zona Ritiro"},
            {"data": "Indirizzo proprietario annuncio"},
            {"data": "Beneficiario"},
            {"data": "Stato Transazione"},
            {"data": "Data Annuncio"},
            {"data": "Azioni"}
        ],
        "oLanguage": commonOLangTabelleAnnunci,
        "aoColumnDefs": [{"bSortable": false, "aTargets": [0, 9]}]
    });
    $('#table-elenco-annunci-cerco').DataTable({
        responsive: true,
        "fnDrawCallback": reinizializzaTooltips,
        "columns": [
            {"data": "Foto"},
            {"data": "Nome Annuncio"},
            {"data": "Oggetto"},
            {"data": "Punto ToornaQui"},
            {"data": "Zona Ritiro"},
            {"data": "Indirizzo proprietario annuncio"},
            {"data": "Beneficiario"},
            {"data": "Stato Transazione"},
            {"data": "Data Annuncio"},
            {"data": "Azioni"}
        ],
        "oLanguage": commonOLangTabelleAnnunci,
        "aoColumnDefs": [{"bSortable": false, "aTargets": [0, 9]}]
    });


    $('#table-elenco-annunci-good-crossing-point, #table-elenco-annunci-ritirati-good-crossing-point').DataTable({
        responsive: true,
        "fnDrawCallback": reinizializzaTooltips,
        "columns": [
            {"data": "Foto"},
            {"data": "Nome Annuncio"},
            {"data": "Oggetto"},
            {"data": "Proprietario"},
            {"data": "Beneficiario"},
            {"data": "Codice"},
            {"data": "Data Assegnazione"},
            {"data": "Tipologia Annuncio"},
            {"data": "Azioni"}
        ],
        "oLanguage": commonOLangTabelleAnnunci,
        "aoColumnDefs": [{"bSortable": false, "aTargets": [0, 8]}]
    });

    $('#table-elenco-annunci-prestito, #table-elenco-annunci-prenotati, #table-elenco-annunci-offro,#table-lista-prenotazione-annunci, #table-elenco-annunci-cerco, #table-elenco-annunci-good-crossing-point, #table-elenco-annunci-ritirati-good-crossing-point').each(function () {
        $(this).DataTable().on('responsive-display', reinizializzaTooltips);
    });

    $('.tooltip-top').tooltip({
        'container': 'body'
    });
    $(document).on('click', '.button-modifica-annuncio', function () {
        window.location.href = wpdm_modifica_annunci_url + '?id_annuncio=' + this.value;
    });
    $(document).on('click', '.button-lista-prenotazione-annuncio', function () {
        window.location.href = wpdm_assegna_annunci_url + '?id_annuncio=' + this.value;
    });
    $('.button-vota').click(function () {
        var id_annuncio = $(this).val();
        var id_annuncioTest = $(this).attr('value');
        
        var voto = $('#select-voto-' + this.value).val();
        var votoTest = $('#select-voto-' + id_annuncioTest).val();
        
        console.log(id_annuncio);
        console.log(voto);
        console.log(id_annuncioTest);
        console.log(votoTest);
        themeSpinner('show');
        $(this).html('Aggiorna feedback');
        $.ajax({//create an ajax request to load_page.php
            type: "POST",
            cache: false,
            url: ajax_url,
            data: {
                action: 'vota_annuncio_action',
                id_annuncio: id_annuncio,
                rating: voto
            },
            dataType: "html", //expect html to be returned                
            success: function (response) {
                if (response === '1')
                {
                    reloadScrollingToTitle();
                } 
                else
                {
                    console.log(response);
                }
                //themeSpinner('hide');
//                location.reload(true);
            },
            error: function (response) {
                themeSpinner('hide');
                console.log('error: ' + response);
            }

        });
    });
    $(document).on('click', '.button-eliminazione-annuncio', function () {

        var r = confirm("Sei sicuro di volere cancellare questo annuncio?");
        if (r == true) {
            themeSpinner('show');
            $.ajax({//create an ajax request to load_page.php
                type: "POST",
                cache: false,
                url: ajax_url,
                data:
                        {
                            action: 'elimina_annuncio_action',
                            id_annuncio: this.value

                        },
                dataType: "html", //expect html to be returned                
                success: function (response) {
                    themeSpinner('hide');
                    location.reload(true);
                },
                error: function () {
                    themeSpinner('hide');
                    $("#messageSelectObject").html('Problemi nell\'eliminazione degli oggetti');
                    $("#messageSelectObject").addClass('alert-danger');
                    $("#messageSelectObject").show();
                }

            });
        }
    });
    //content annuncio
    $(document).on('click', '.button-cancella-annuncio', function () {

        var r = confirm("Sei sicuro di volere cancellare questo annuncio?");
        if (r == true) {
            themeSpinner('show');
            $.ajax({//create an ajax request to load_page.php
                type: "POST",
                cache: false,
                url: ajax_url,
                data:
                        {
                            action: 'elimina_annuncio_action',
                            id_annuncio: this.value

                        },
                dataType: "html", //expect html to be returned                
                success: function (response) {
                    themeSpinner('hide');
                    document.location.href="/";
                },
                error: function () {
                    themeSpinner('hide');
                    $("#messageSelectObject").html('Problemi nell\'eliminazione degli oggetti');
                    $("#messageSelectObject").addClass('alert-danger');
                    $("#messageSelectObject").show();
                }

            });
        }
    });
});

